import React from 'react';
import PropTypes from 'prop-types';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';
import { createFragmentContainer, graphql } from 'react-relay';
import { DEFAULT_LOCATION_CODES } from '../sbSharedRefineMenuConstants';

// components
import { SbSharedRefineMenuRadioSelectSearch } from '../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelectSearch';

export const SbSharedRefineMenuFilterLocationComponent = props => {
    const {
        values,
        searchBrowse: { appliedFilters },
        filterName,
    } = props;

    /**
     * We always want to show USA, EUROPE and then any active location filter in that order.
     *
     * To accomplish this we will filter out then sort by their code
     *     USA code -> 1
     *     Europe code -> 2
     *     Selected code should always be higher
     */

    const appliedFilterCodes = getFilterValues(appliedFilters, filterName).map(
        filter => filter.code
    );
    const displayLocationCodes = [...DEFAULT_LOCATION_CODES, ...appliedFilterCodes];

    const displayValues = values
        .filter((value = {}) => displayLocationCodes.indexOf(value.code) > -1)
        .sort((a = {}, b = {}) => Number(a.code) - Number(b.code));

    return <SbSharedRefineMenuRadioSelectSearch {...props} values={displayValues} />;
};

SbSharedRefineMenuFilterLocationComponent.propTypes = {
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    searchBrowse: PropTypes.object.isRequired,
};

export const SbSharedRefineMenuFilterLocation = createFragmentContainer(
    SbSharedRefineMenuFilterLocationComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterLocation_viewer on Viewer {
                ...SbSharedRefineMenuRadioSelectSearch_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterLocation_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuRadioSelectSearch_searchBrowse
                appliedFilters {
                    name
                    values {
                        code
                    }
                }
            }
        `,
    }
);
